export default "<abw-document-scanner-form (change)=\"onValueChanged($event)\" [model]=\"model\" [attr.id]=\"model.id\"></abw-document-scanner-form>";